import DownloadIcon from "@mui/icons-material/Download";
import { IconButton } from "@mui/material";
import { useToast } from "../components/Toast";
function InvoiceList({ subDetails }) {
  const token = localStorage.getItem("token");
  const Toast = useToast();
  const handleInvoiceDownload = async (subscriptionId, invoiceId) => {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_API_HOST_URL}/v1/subscription/doctor/${subscriptionId}/invoice/${invoiceId}/download`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const json = await resp.json();
      const url = json?.data?.url;

      if (url) {
        const fullUrl = url.startsWith("http")
          ? url
          : `${process.env.REACT_APP_API_HOST_URL}/${url}`;

        const link = document.createElement("a");
        link.href = fullUrl;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.click();
      } else {
        console.error("No invoice URL returned from API");
        Toast.error("Invoice not available");
      }
    } catch (error) {
      console.error("Error downloading invoice:", error);
    }
  };

  return (
    <div>
      {subDetails?.map((sub, subIndex) => (
        <div key={subIndex} style={{ marginBottom: "20px" }}>
          {/* Optional section header */}
          <h3 style={{ marginBottom: "10px" }}>
            {sub.planName || `Subscription ${subIndex + 1}`}- status:{" "}
            {sub.status}
          </h3>

          {/* Loop invoiceFiles inside each subDetail */}
          {sub?.invoiceFiles
            ?.filter((file) => file.url) // only if URL exists
            ?.map((file) => (
              <div
                key={file._id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 0",
                  borderBottom: "1px solid #ddd",
                }}
              >
                <span>{file.fileName}</span>
                <IconButton
                  onClick={() => handleInvoiceDownload(sub._id, file._id)}
                >
                  <DownloadIcon />
                </IconButton>
              </div>
            ))}

          {/* If no URL invoice exists */}
          {(!sub?.invoiceFiles ||
            sub.invoiceFiles.filter((f) => f.url).length === 0) && (
            <p style={{ color: "#999" }}>No downloadable invoices</p>
          )}
        </div>
      ))}
    </div>
  );
}

export default InvoiceList;
